import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import capitalizeFirstLetter from "../../helpers/capitalize-first-letter";
import shortenName from "../../helpers/shorten-name";

const getCTAColumns = (isOpen = true) => {
  const column = isOpen ? "requested" : "resolved";
  const columnName = capitalizeFirstLetter(column);

  return [
    {
      name: `${columnName} At`,
      selector: `${column}At`,
      sortable: true,
      cell: (row) => {
        return moment(row[`${column}At`]).format("M/D/YY - HHmm");
      },
      minWidth: "80px",
      maxWidth: "110px",
    },
    {
      name: "Trip #",
      selector: "trip.tripTag",
      sortable: true,
      cell: (row) => {
        return (
          <Link className="ellipsis-cell" to={`/trips/${row.trip?._id}`} target="_blank" rel="noopener noreferrer">
            <Tooltip title={row.trip?.tripTag} arrow>
              {row.trip?.tripTag}
            </Tooltip>
          </Link>
        );
      },
      width: "80px",
    },
    {
      name: "Client / Operator",
      selector: "clientOrOperator",
      sortable: true,
      wrap: true,
      minWidth: "120px",
      cell: (row) => {
        return <div className="two-line-content">{row.clientOrOperator}</div>;
      },
    },
    {
      name: `Action ${isOpen ? "Needed" : "Taken"}`,
      sortable: false,
      wrap: true,
      minWidth: "150px",
      cell: (row) => {
        const link = row.source === "ofr" ? `/trips/${row.trip?._id}?ofrId=${row._id}` : `/trips/${row.trip?._id}/contracts/${row._id}/preview`;

        return <Link to={link} target="_blank" rel="noopener noreferrer">{row.actionLabel}</Link>;
      },
    },
    {
      name: "Dates",
      selector: "firstDeparture",
      sortable: true,
      minWidth: "90px",
      maxWidth: "120px",
      cell: (row) => {
        if (!row.lastDeparture || moment(row.firstDeparture).format("M/D/YY") === moment(row.lastDeparture).format("M/D/YY")) {
          return moment(row.firstDeparture).format("M/D/YY");
        }

        return `${moment(row.firstDeparture).format("M/D/YY")} - ${moment(row.lastDeparture).format("M/D/YY")}`;
      },
    },
    {
      name: `${columnName} By`,
      selector: `${column}By`,
      sortable: true,
      wrap: true,
      width: "110px",
      cell: (row) => shortenName(row[`${column}By`]),
    },
  ];
};

const ctaOpenColumns = getCTAColumns(true);
const ctaResolvedColumns = getCTAColumns(false);

export { ctaOpenColumns, ctaResolvedColumns };
